import { ColumnDef } from '@benzinga/table';

import { ReturnChip, SecurityNameCell, SecurityTickerLink } from './TableCells';

export const MemberTopColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { company_name, logo, ticker } = data;
      return <SecurityNameCell logo={logo} name={company_name} ticker={ticker} />;
    },
    field: 'company_name',
    headerName: 'Name',
    sortEnabled: true,
    width: 220,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <SecurityTickerLink ticker={data.ticker} />,
    field: 'ticker',
    headerName: 'Symbol',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    field: 'exchange',
    headerName: 'Exchange',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ReturnChip value={data?.return} />,
    field: 'return',
    headerName: 'Return',
    sortEnabled: true,
    width: 100,
  },
] as ColumnDef<any>[];
